import { atom } from 'jotai';
import { PointOfInterest } from '@/__generated__/graphql';

export const reviewScreenPoisState = atom<PointOfInterest[]>([]);
export const currentPoiIndexState = atom<number>(0);
export const selectedPoiForPreviewState = atom<PointOfInterest | undefined>(undefined);

export const currentPoiState = atom((get) => {
  const pois = get(reviewScreenPoisState);
  const currentIndex = get(currentPoiIndexState);
  return pois[currentIndex];
});

type PoiNavigationAction =
  | { type: 'next' | 'previous'; payload?: string }
  | { type: 'setIndex'; payload: number }
  | { type: 'setPois'; payload: PointOfInterest[] };

export const poiNavigationActionsState = atom(null, (get, set, action: PoiNavigationAction) => {
  const pois = get(reviewScreenPoisState);
  const currentIndex = get(currentPoiIndexState);

  switch (action.type) {
    case 'next':
      if (pois.length > 0) {
        const nextIndex = currentIndex < pois.length - 1 ? currentIndex + 1 : 0;
        set(currentPoiIndexState, nextIndex);
        set(selectedPoiForPreviewState, pois[nextIndex]);
      }
      break;
    case 'previous':
      if (pois.length > 0) {
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : pois.length - 1;
        set(currentPoiIndexState, prevIndex);
        set(selectedPoiForPreviewState, pois[prevIndex]);
      }
      break;
    case 'setIndex':
      if (action.payload >= 0 && action.payload < pois.length) {
        set(currentPoiIndexState, action.payload);
        set(selectedPoiForPreviewState, pois[action.payload]);
      }
      break;
    case 'setPois':
      set(reviewScreenPoisState, action.payload || []);
      break;
  }
});
